import { atom } from "recoil";

export const CurrentCustomerAssetSizeState = atom<number>({
  key: "currentCustomerAssetSizeState",
  default: 0,
});
